export const PURCHASE_LIMIT_FORM_DEFAULTS = {
  purchase_limit_per_order: '',
  purchase_limit_per_user: '',
  purchase_limit_start_at: '',
  purchase_limit_end_at: '',
};

const AMOUNT_KEYS = ['purchase_limit_per_order', 'purchase_limit_per_user'];
const DATE_KEYS = ['purchase_limit_start_at', 'purchase_limit_end_at'];

export const toPurchaseLimitFormValues = (source = {}) =>
  [...AMOUNT_KEYS, ...DATE_KEYS].reduce(
    (acc, key) => ({
      ...acc,
      [key]: source[key] === null || source[key] === undefined ? '' : source[key],
    }),
    {}
  );

export const toPurchaseLimitPayload = (values = {}) => ({
  ...AMOUNT_KEYS.reduce(
    (acc, key) => ({
      ...acc,
      [key]: values[key] === '' || values[key] === undefined ? null : Number(values[key]),
    }),
    {}
  ),
  ...DATE_KEYS.reduce(
    (acc, key) => ({
      ...acc,
      [key]: values[key] === '' || values[key] === undefined ? null : values[key],
    }),
    {}
  ),
});
